/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Fortschrittsanzeige im Fussbereich
 * +---------------------------------------------------+
 * | 2.000 / 4.500 GB                                  |
 * +---------------------------------------------------+
 * | --------->                                    (X) |
 * +---------------------------------------------------+
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IoMdCloseCircle } from 'react-icons/io';

import * as utils from "../../basics/utils"
import * as appActions from "../../store/actions/appActions";
import * as syncActions from "../../store/actions/syncActions";

class ProgressBar extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    render() {
        const { windowHeight, toolbarHeight, unitHeight } = this.props.app;
        const { progress, syncCancel, syncType } = this.props.sync;

        if (syncType === '') return null;

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        const renderProgressBar = () => {
            if (progress === null || progress.totalBytes === 0) return null;

            const helpCurrentBytes = Math.min(progress.currentBytes, progress.totalBytes);

            const bytes = '' + utils.humanFileSize(helpCurrentBytes) + ' / ' + utils.humanFileSize(progress.totalBytes);
            const label = parseInt(progress.totalPercent) + '%'
            const width = progress.totalPercent + '%'

            const styleProgressBar = { backgroundColor: 'rgb(145,28,33)', width: width, ...utils.getStyleHeight(toolbarHeight, .4, .3, .15) };

            return (
                <div className="w-11/12 flex py-2">
                    <div className="w-full flex flex-col">
                        <div className="w-full h-full" style={utils.getStyleHeight(unitHeight, .2, .2, .15)}>{bytes}</div>
                        <div className="py-1 text-center text-white" style={styleProgressBar}>{label}</div>
                    </div>
                </div>
            )
        }

        const renderCancelButton = () => {
            if (syncType === 'syncPortfolio') return null;

            const onSyncCancel = () => {
                !syncCancel && this.props.setSyncCancel(true);
            }

            const style = { opacity: syncCancel ? .1 : 1, ...utils.getStyleHeight(unitHeight, 1, 1, .4) };

            return (
                <div className="w-1/12 h-full flex justify-center items-center" style={style} onClick={onSyncCancel}><IoMdCloseCircle /></div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            top: windowHeight - toolbarHeight,
            height: toolbarHeight
        }

        return (
            <div className="absolute w-full font-mono bg-gray-600 text-white" style={style}>
                <div className="w-full h-full flex pl-2">
                    {renderProgressBar()}
                    {renderCancelButton()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        sync: state.sync
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, syncActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar);
